'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$routeParams', '$log', '$uibModalInstance', '$uibModal', '$security', 'chronology', 'edit', 'chronologies',
                function($scope, $routeParams, $log, $modalInstance, $modal, $security, chronology, edit, chronologies) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.edit = edit;

                    $scope.dateFormat = 'dd.MM.yyyy';

                    $scope.chronology = angular.copy(chronology);
                    $scope.chronologies = angular.copy(chronologies);

                    if (!angular.equals(chronology, {})) {
                        $scope.title = 'Редактирование события';

                        $scope.chronologies.splice(chronologies.indexOf(chronology), 1);
                    } else {
                        $scope.title = 'Создание нового события';

                        let _user = $security.getUser();

                        let _userName = _user.username;

                        if (_user.staff) {
                            _userName = _user.staff.shortName;
                        }

                        $scope.chronology = {
                            eventDate: new Date(),
                            user: {
                                id: _user.id,
                                name: _userName,
                            },
                        };
                    }

                    // region Function

                    function ok() {
                        $modalInstance.close($scope.chronology);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    // endregion
                }];
